import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Textbox, Custom } from '@app/shared';
import { Validators } from '@angular/forms';
import {
  ClasificacionPredeterminada
} from '@app/shared';

@Injectable()
export class DocumentClassificationFormService {

  constructor() { }

  /**
   * Construye y retorna el formulario para agregar o modificar la clasificación de un documento
   *
   * @param {TemplateRef<any>} templateUpload
   * @param {ClasificacionPredeterminada} [documentClassification]
   * @returns {BaseControl<any>[]}
   * @memberof DocumentClassificationFormService
   */
  getFormDocumentClassification(
    templateUpload: TemplateRef<any>,
    documentClassification?: ClasificacionPredeterminada
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'nombre',
        value: documentClassification ? documentClassification.nombre ? documentClassification.nombre : null : null,
        label: 'Nombre',
        placeholder: 'Nombre de la clasificación',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'vista_previa',
        label: 'Vista previa',
        order: 2,
        template: templateUpload
      }),
      new Custom({
        key: 'generacion',
        label: 'Generación',
        order: 3,
        template: templateUpload
      }),
      new Textbox({
        key: 'solicitud',
        type: 'checkbox',
        label: 'Solicitud',
        order: 4,
        size: 'col-12',
        value: documentClassification ? documentClassification.solicitud : false
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/documents/document-classification/shared/document-classification-form.service.ts